import DefaultLayout from "@/layouts/DefaultLayout";
import KDriverTimeOffForm from "kinnect-front/KYard/Drivers/KDriverTimeOffForm";
import { FetchesData, Pageable } from "kinnect-mixins";
import { KActionDialog, KDateTimeRange } from "kinnect-general";
import {
	VList,
	VListItem,
	VListItemContent,
	VSubheader
} from "vuetify/lib";
import {
	deleteDriverTimeOff,
	getDriverTimeOff,
	getDriverTimesOff
} from "@/utils/http-calls";
import { sortByKey } from "kinnect-helpers";

export default {
	name: "YardDriverTimeOffPage",

	metaInfo() {
		const title = this.editing
			? "Yard - Drivers - Time Off"
			: "Yard - Drivers - Add Time Off";

		return { title };
	},

	mixins: [
		FetchesData,
		Pageable
	],

	props: {
		idDriver: {
			required: true,
			type: Number
		},
		idTimeOff: Number
	},

	data: () => ( {
		deleteDialogOpen: null,
		existingTimesOff: null,
		timeOff: null
	} ),

	computed: {
		editing() {
			return Boolean( this.idTimeOff );
		},

		canEditYardDrivers() {
			return this.$can( "edit_yard_drivers" );
		},

		otherTimesOff() {
			if ( this.existingTimesOff && this.timeOff ) {
				if ( this.editing ) {
					return this.existingTimesOff.filter( timeOff => timeOff.id !== this.timeOff.id );
				}

				return this.existingTimesOff;
			}

			return null;
		},

		numOtherTimesOff() {
			return this.otherTimesOff ? this.otherTimesOff.length : 0;
		},

		genDeleteDialog() {
			if ( this.editing && this.timeOff && this.canEditYardDrivers ) {
				return <KActionDialog
					confirmButtonColor="error"
					confirmButtonText="Delete"
					loading={this.$wait.is( "deleteDriverTimeOff" )}
					onConfirm={this.deleteDriverTimeOff}
					redirect={[ "back", {
						name: "yardDriver",
						params: { idDriver: this.idDriver }
					} ]}
					title="Delete Time Off"
					vModel={this.deleteDialogOpen}
				>Are you sure you want to delete this time off?</KActionDialog>;
			}
		},

		genOtherTimesOffHeader() {
			return <VSubheader>
				{this.numOtherTimesOff ? "Other Time Off" : "No Other Time Off"}
			</VSubheader>;
		},

		genOtherTimesOffList() {
			if ( this.numOtherTimesOff ) {
				return <VList class="list--auto-height" dense>
					{this.otherTimesOff.map( timeOff =>
						<VListItem
							activeClass={this.dark ? "grey darken-2" : "grey lighten-2"}
							key={timeOff.id}
							ripple
							to={{
								name: "yardDriverTimeOff",
								params: {
									idDriver: this.idDriver,
									idTimeOff: timeOff.id
								}
							}}
						>
							<VListItemContent>
								<KDateTimeRange
									allDay={Boolean( timeOff.allDay )}
									endDate={timeOff.endDate}
									endTime={timeOff.endTime}
									startDate={timeOff.startDate}
									startTime={timeOff.startTime}
								></KDateTimeRange>
							</VListItemContent>
						</VListItem>
					)}
				</VList>;
			}
		},

		genOtherTimesOff() {
			return [
				this.genOtherTimesOffHeader,
				this.genOtherTimesOffList
			];
		},

		toolbarActions() {
			if ( this.editing && this.canEditYardDrivers ) {
				return {
					icon: "delete",
					onClick: () => this.deleteDialogOpen = true,
					text: "Delete Time Off",
					tooltip: "Delete this time off"
				};
			}
		}
	},

	watch: {
		idTimeOff() {
			this.fetch();
		}
	},

	methods: {
		deleteDriverTimeOff() {
			return deleteDriverTimeOff( this.idDriver, this.idTimeOff )
			.then( () => this.$store.commit( "toasts/SHOW", {
				color: "success",
				text: "Time off deleted"
			} ) );
		},

		async fetchExistingTimesOff() {
			const existingTimesOff = await getDriverTimesOff( this.idDriver );

			this.existingTimesOff = sortByKey( existingTimesOff, "startDate" ).reverse();
		},

		async fetchTimeOff() {
			if ( this.editing ) {
				this.timeOff = await getDriverTimeOff( this.idDriver, this.idTimeOff, true );
			}
		},

		async fetch() {
			await this.$http.all( [
				this.fetchTimeOff(),
				this.fetchExistingTimesOff()
			] );
		}
	},

	render() {
		return <DefaultLayout>
			<KDriverTimeOffForm
				idDriver={this.idDriver}
				loading={this.$wait.is( "getDriverTimeOff" )}
				timeOff={this.timeOff}
			></KDriverTimeOffForm>

			{this.genDeleteDialog}

			<template slot="leftSidebar">
				{this.genOtherTimesOff}
			</template>
		</DefaultLayout>;
	}
};
